import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Reklam/kaynak takibi: ?src=insta gibi gelindiyse, yönlendirmelerden önce yakala ve sakla.
// Kayıt olunca tüketilir. (UTM benzeri; kullanıcı görmez.)
try {
  const src = new URLSearchParams(window.location.search).get('src');
  if (src && src.trim()) {
    localStorage.setItem('signupSource', src.trim().toLowerCase().slice(0, 50));
  }
} catch { /* yoksay */ }

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
